import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/ProtectedRoute";

const API = ""; // same-origin now — Vercel rewrites /api/* to the backend (see client/vercel.json). Keeps the session cookie first-party for Safari/Firefox.

function AdBanner({ onClose }) {
  return (
    <div style={{
      background: "linear-gradient(135deg, #1a1a2e, #16213e)",
      border: "1px solid #2a2a4a",
      borderRadius: 10,
      padding: "10px 16px",
      margin: "0 16px 16px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }}>
      <div>
        <span style={{ color: "#555", fontSize: 9, textTransform: "uppercase", letterSpacing: 1 }}>Advertisement</span>
        <p style={{ color: "#aaa", margin: "2px 0 0 0", fontSize: 13 }}>
          🌟 Upgrade to Ultra Pro — Ad-Free experience ke liye!
        </p>
      </div>
      <span onClick={onClose} style={{ color: "#FF6B00", fontSize: 18, cursor: "pointer", padding: "0 4px" }}>✕</span>
    </div>
  );
}

export default function Account() {
  const navigate = useNavigate();
  const auth = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [adVisible, setAdVisible] = useState(true);
  const token = localStorage.getItem("subai_session"); // non-sensitive "am I logged in" flag now — real session is the httpOnly cookie

  useEffect(() => {
    if (!token) { navigate("/"); return; }
    fetch(`${API}/api/profile`, {
      headers: { Authorization: "Bearer " + token }
    }).then(r => r.json())
      .then(d => { setProfile(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const logout = async () => {
    if (!window.confirm("🚪 Kya aap sach mein logout karna chahte ho?")) return;
    // Waits for the server to clear the cookie; if it can't, the user stays logged in and is told so.
    const ok = await auth.logout();
    if (!ok) return alert("Logout nahi ho paya (server tak nahi pahunch sake). Internet check karke dobara try karo.");
    navigate("/login", { replace: true });
  };

  if (loading) return (
    <div style={styles.centerPage}>
      <div style={styles.spinner} />
      <p style={{ color: "#555", marginTop: 14, fontSize: 13 }}>Load ho raha hai...</p>
    </div>
  );

  if (!profile) return (
    <div style={styles.centerPage}>
      <p style={{ color: "#888" }}>Profile load nahi hoi ❌</p>
    </div>
  );

  const planMap = {
    free:      { label: "Free",      color: "#888",    bg: "#181818", border: "#2a2a2a", icon: "🆓", glow: "none" },
    pro:       { label: "Pro",       color: "#FF6B00", bg: "#1c0d00", border: "#FF6B0044", icon: "⚡", glow: "0 0 24px #FF6B0033" },
    ultra_pro: { label: "Ultra Pro", color: "#FFD700", bg: "#1a1500", border: "#FFD70044", icon: "🌟", glow: "0 0 24px #FFD70033" },
  };
  const plan = planMap[profile.plan] || planMap.free;

  const expStr = profile.planExpiry
    ? new Date(profile.planExpiry).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })
    : null;

  const avatarLetter = (profile.name || "U")[0].toUpperCase();

  return (
    <div style={styles.page}>

      {/* Ad Banner */}
      {adVisible && profile?.showAds && (
        <AdBanner onClose={() => setAdVisible(false)} />
      )}

      {/* Navbar */}
      <div style={styles.navbar}>
        <button onClick={() => navigate("/dashboard")} style={styles.backBtn}>←</button>
        <span style={styles.navTitle}>My Account</span>
        <div style={{ width: 36 }} />
      </div>

      <div style={styles.container}>

        {/* ── Avatar Section ── */}
        <div style={styles.avatarSection}>
          <div style={styles.avatarRing}>
            <div style={styles.avatar}>{avatarLetter}</div>
          </div>
          <h2 style={styles.name}>{profile.name || "User"}</h2>
          <p style={styles.emailText}>{profile.email}</p>
        </div>

        {/* ── Plan Card ── */}
        <div style={{ ...styles.planCard, background: plan.bg, borderColor: plan.border, boxShadow: plan.glow }}>
          <div style={styles.planLeft}>
            <span style={styles.planIcon}>{plan.icon}</span>
            <div>
              <div style={styles.planSmallLabel}>Current Plan</div>
              <div style={{ color: plan.color, fontSize: 22, fontWeight: 800, lineHeight: 1 }}>{plan.label}</div>
            </div>
          </div>
          <div style={styles.planRight}>
            {profile.plan !== "free" && profile.planActive && expStr
              ? <>
                  <div style={styles.planSmallLabel}>Expires</div>
                  <div style={{ color: "#ccc", fontSize: 13, fontWeight: 600 }}>{expStr}</div>
                </>
              : profile.plan !== "free"
                ? <span style={{ color: "#ff4444", fontWeight: 700, fontSize: 13 }}>❌ Expired</span>
                : <span
                    onClick={() => navigate("/premium")}
                    style={{ color: "#FF6B00", fontSize: 12, cursor: "pointer", fontWeight: 600 }}
                  >Upgrade karo →</span>
            }
          </div>
        </div>

        {/* ── Info Rows ── */}
        <div style={styles.infoCard}>
          <Row label="📛 Name"   value={profile.name || "—"} />
          <Row label="📧 Email"  value={profile.email} />
          <Row
            label="🔔 Ads"
            value={profile.showAds ? "Dikh rahe hain" : "Ad-Free ✅"}
            valueColor={profile.showAds ? "#888" : "#00C896"}
          />
          <Row
            label="⚡ AI Translation"
            value={profile.canUseAPI ? "Available ✅" : "Pro lo"}
            valueColor={profile.canUseAPI ? "#00C896" : "#ff6644"}
            last
          />
        </div>

        {/* ── Upgrade button ── */}
        {(profile.plan === "free" || !profile.planActive) && (
          <button onClick={() => navigate("/premium")} style={styles.upgradeBtn}>
            💎 Pro / Ultra Pro mein Upgrade Karo
          </button>
        )}

        {/* ── Logout ── */}
        <button onClick={logout} style={styles.logoutBtn}>
          🚪 Logout
        </button>

        <p style={styles.logoutHint}>Logout karne par aapka session khatam ho jayega</p>

      </div>
    </div>
  );
}

function Row({ label, value, valueColor, last }) {
  return (
    <div style={{
      display: "flex", justifyContent: "space-between",
      alignItems: "center", padding: "14px 0",
      borderBottom: last ? "none" : "1px solid #1e1e1e",
      gap: 12,
    }}>
      <span style={{ color: "#666", fontSize: 14, flexShrink: 0 }}>{label}</span>
      <span style={{
        color: valueColor || "#ccc", fontSize: 13,
        fontWeight: 600, textAlign: "right",
        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "60%"
      }}>{value}</span>
    </div>
  );
}

const styles = {
  page: { minHeight: "100vh", background: "#0D0D0D", color: "#E8E8E8", fontFamily: "sans-serif" },
  centerPage: { minHeight: "100vh", background: "#0D0D0D", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" },
  spinner: { width: 32, height: 32, border: "3px solid #222", borderTop: "3px solid #FF6B00", borderRadius: "50%", animation: "spin 0.8s linear infinite" },

  navbar: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "14px 16px", borderBottom: "1px solid #1a1a1a",
    position: "sticky", top: 0, background: "#0D0D0D", zIndex: 10,
  },
  backBtn: {
    background: "none", border: "1px solid #2a2a2a", color: "#aaa",
    width: 36, height: 36, borderRadius: 10, cursor: "pointer", fontSize: 18,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  navTitle: { fontSize: 16, fontWeight: 700, color: "#E8E8E8" },

  container: { maxWidth: 480, margin: "0 auto", padding: "28px 16px 80px 16px", display: "flex", flexDirection: "column", gap: 14 },

  avatarSection: { display: "flex", flexDirection: "column", alignItems: "center", gap: 8, paddingBottom: 4 },
  avatarRing: {
    padding: 3, borderRadius: "50%",
    background: "linear-gradient(135deg, #FF6B00, #7B61FF)",
    marginBottom: 4,
  },
  avatar: {
    width: 72, height: 72, borderRadius: "50%",
    background: "#1a1a1a",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 30, fontWeight: 800, color: "#fff",
  },
  name: { fontSize: 20, fontWeight: 800, margin: 0, color: "#fff" },
  emailText: { fontSize: 13, color: "#555", margin: 0 },

  planCard: {
    borderRadius: 16, border: "1px solid",
    padding: "18px 20px",
    display: "flex", justifyContent: "space-between", alignItems: "center",
  },
  planLeft: { display: "flex", alignItems: "center", gap: 14 },
  planIcon: { fontSize: 34 },
  planSmallLabel: { color: "#666", fontSize: 10, letterSpacing: 1, textTransform: "uppercase", marginBottom: 2 },
  planRight: { textAlign: "right" },

  infoCard: {
    background: "#161616", border: "1px solid #1e1e1e",
    borderRadius: 16, padding: "0 18px",
  },

  upgradeBtn: {
    width: "100%", padding: "14px",
    background: "linear-gradient(135deg, #FF6B00, #e05500)",
    border: "none", borderRadius: 14,
    color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer",
  },

  logoutBtn: {
    width: "100%", padding: "14px",
    background: "none",
    border: "1px solid #2a2a2a",
    borderRadius: 14, color: "#ff4444",
    fontSize: 15, fontWeight: 600, cursor: "pointer",
    transition: "background 0.2s",
  },
  logoutHint: { color: "#333", fontSize: 11, textAlign: "center", margin: "0" },
};
